<template>
    <LoadingSpinner v-if="loading" />

    <div class="page-content">
        <div class="content">
            <h1 class="pqHeadFirst">
                {{ title }}
            </h1>
            <h2 class="pqHeadSec">
            </h2>
            <span class="pqHeadThird">
            </span>
        </div>
        <div class="bg-image-sq">
            <img class="mfg-img-bg bg-image" v-bind:src="bgSq" />
        </div>
    </div>

    <div class="mfgHeaderRow">
        <div class="mfgFilters">
            <div v-for="control in filterList" :key="control.MatId">
                <div class="mfgFilterBox">
                    <div class="mfgFilterControl">
                        <DxSelectBox :items="control.ListEntries"
                                     valueExpr="LitId"
                                     :showClearButton="true"
                                     v-model:value="control.filterValue"
                                     displayExpr="LitName"
                                     :placeholder="control.MatCaption" />
                    </div>
                </div>
            </div>
            <div class="mfgSearch">
                <DxTextBox v-model:text="searchText" :width="350"></DxTextBox>
                <div class="searchButton>"><i class="fa-solid fa-magnifying-glass"></i> </div>
            </div>
        </div>
    </div>
    <div class="home" id="cisRsi">
        <div class="tsKampagnenBox" v-if="cardListFiltered && cardListFiltered.length>0">
            <div v-for="data in cardListFiltered" :key="data.TopicId" class="tsFor">
                <div class="tsKampagne">
                    <div class="tsSuchfeldBox" @click="OpenMore(data)">
                        <div class="tsFor tsForIn">
                            <div class="tsSuchfeld">
                                <div v-if="data.ImgUrl" :class="{tsSuchfeldImage:true}">
                                    <img :src="data.ImgUrl" />
                                </div>
                                <div v-else class="rsiNoImage tsSuchfeldImage">
                                    <i class="fa fa-image rsiNoImageIcon"></i>
                                </div>
                                <div class="tsThemes">
                                    <div v-for="item in data.MultiSelect" :key="item.LitName" class="tsImg">
                                        <span v-if="item.LitIcon" :title="item.LitName">
                                            <i :class="item.LitIcon"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="tsLinkStatsBox">
                                    <div class="tsLinkStats" v-if="data.ProjectsCount>0">
                                        <div class="tsLinkStatsLabel">related projects:&nbsp;</div><div class="tsLinkStatsValue">{{ data.ProjectsCount}}</div>
                                    </div>
                                    <div class="tsLinkStats" v-if="data.PoliciesCount>0">
                                        <div class="tsLinkStatsLabel">related policies:&nbsp;</div><div class="tsLinkStatsValue">{{ data.PoliciesCount}}</div>
                                    </div>
                                    <div class="tsLinkStats" v-if="data.StakeholdersCount>0">
                                        <div class="tsLinkStatsLabel">related stakeholders:&nbsp;</div><div class="tsLinkStatsValue">{{ data.StakeholdersCount}}</div>
                                    </div>
                                </div>
                                <div :class="{tsSuchfeldTitle:true}">
                                    {{  data.Title }}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="noevent" v-else>
            No Records
        </div>

    </div>

</template>

<script>
    import $ from 'jquery';
    //import { DxButton } from 'devextreme-vue/button';
    import { DxTextBox } from 'devextreme-vue/text-box';
    import DxSelectBox from 'devextreme-vue/select-box'
    import LoadingSpinner from "@/views/widgets/LoadingSpinner";
    import axios from 'axios'
    const baseUri = "WebApi.asmx/api/topicLinkService";
    const baseUri2 = "WebApi.asmx/api/listService";


    export default {
        name: 'EventsOverview',
        components: {
            //DxButton,
            LoadingSpinner,
            DxTextBox,
            DxSelectBox
        },
        data() {
            return {
                bgSq: "",
                loading: false,
                cardList: [],
                filterList: [],
                searchText: "",
            }
        },
        computed: {
            cardListFiltered() {
                var result = this.cardList.filter((item) => {
                    return (item.Title && item.Title.toLowerCase().includes(this.searchText.toLowerCase())) ||
                        (item.TpcDescription && item.TpcDescription.toLowerCase().includes(this.searchText.toLowerCase()));
                });
                if (this.filterList && result) {
                    this.filterList.forEach(m => {
                        result = result.filter(f => {
                            return m.filterValue > 0 ?
                                f[m.AtrName2].filter(a => {
                                    return a.LitId == m.filterValue;
                                }).length > 0
                                : true;
                        })
                    });
                }
                return result;
            },
            args() {
                let uri = window.location.search.substring(1);
                let params = new URLSearchParams(uri);
                return params.get("args");
            },
        },
        mounted() {
            this.loading = true;
            Promise.all([
                this.$store.dispatch("getAccessList", { tokenList: ["300751"] }),
                this.loadCardList(),
                this.loadFilterList()
            ]).then(() => {
                this.loading = false;
            });

        },
        created: function () {


        },
        props: {
            title: {
                type: String,
                required: false,
            },
            ttyId: {
                type: Number,
                required: true,
            },
            filterControls: {
                type: Array,
                required: false,
            }
        },
        watch: {

        },
        methods: {
            OpenMore(data) {
                this.loading = true;
                $("form").attr("action", window.location.pathname + "?action=view&id=" + data.TopicId).submit()
            },
            backToOverview() {
                window.location.href = window.location.pathname + "?action=back&args=" + this.args;
            },
            loadCardList() {
                return axios
                    .get(baseUri + '/GetEsaTopicCardList', { params: { ttyId: this.ttyId, stgId: 0 } })
                    .then(res => {
                        if (res.data.success == true) {
                            var list = res.data.cardList;
                            list.forEach(m => {
                                //merge three arrays into one array
                                m.MultiSelect = m.MultiSelect1.concat(m.MultiSelect2, m.MultiSelect3).filter(m => { return m.LitIcon != null; });
                            })
                            this.cardList = list;
                        }
                        else {
                            alert(res.data.errorMessage);
                        }
                        return res;
                    });
            },
            loadFilterList() {
                if (!this.filterControls || this.filterControls.length == 0) {
                    return;
                }
                var matIdList = this.filterControls.map(m => m.matId);
                return axios
                    .get(baseUri2 + '/GetListValuesByMatId', { params: { matIdList: JSON.stringify(matIdList) } })
                    .then(res => {
                        if (res.data.success == true) {
                            var list = res.data.data;
                            list.forEach(m => {
                                m.filterValue = 0;
                                m.AtrName2 = m.AtrName.replace("TdgMultiSelect00", "MultiSelect");
                            })
                            this.filterList = list;
                        }
                        else {
                            alert(res.data.errorMessage);
                        }
                        return res;
                    });
            }
        }
    }

</script>
<style scoped>
    .mfgHeaderRow {
        display: flex;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .mfgFilters {
        display: flex;
        gap: 20px;
        margin-right: 20px;
    }

    .tsLinkStats {
        display: flex;
        font-size: 13px;
    }

    .mfgFilterControl {
        width: 350px;
    }

    .mfgSearch {
        display: flex;
    }

        .mfgSearch i {
            margin-left: -24px;
            margin-top: 11px;
        }


    i.fa-solid.fa-thumbtack {
        color: #313741;
        font-size: 40px;
        transform: rotate(-45deg);
        position: absolute;
        z-index: 5;
        margin-top: -38px;
        margin-left: -31px;
    }

    .pinned .tsSuchfeld {
        grid-template-columns: 2fr 1fr;
        column-gap: 20px;
    }

    .tltStatus {
        padding: 8px 0px 0px 0px;
    }

    .uhr-time {
        display: flex;
        flex-direction: column;
        padding-bottom: 10px;
    }

    .rsiNoImageIcon {
        font-size: 168px;
        color: #b5b5b5;
    }

    .rsiNoImage {
        display: grid;
        justify-items: center;
        align-items: center;
        height: inherit;
    }

    .tsSuchfeldImage.rsiNoImage {
        width: 100%;
        object-fit: cover;
        height: 225px;
    }
    /*
    .tsSuchfeldDate span {
        display: grid;
        column-gap: 6px;
        align-items: center;
        grid-template-columns: auto 1fr;
    }*/
    .fa-location-dot {
        padding-right: 5px
    }

    .tltDevider {
        border-bottom: solid 1px silver;
    }

    .tsEventDate {
        color: #6c757d;
        font-weight: 400;
        border-radius: 3px;
        column-gap: 10px;
        /*padding: 2px 0px 5px;*/
        font-size: 15px;
    }

    span.location {
        padding-left: 20px;
        line-height: 1.5em;
    }

    .noevent {
        color: #00a6c3;
        font-weight: 600;
        text-align: center;
        height: 100%;
        font-size: 20px;
        margin-top: 30px;
    }

    .mfgPopUpText {
        font-weight: normal;
        margin: 0px 5px 10px 0px;
        font-size: 13px;
    }

    .notice {
        color: #00a5c3
    }

    .isExpired {
        filter: grayscale(0.7);
        opacity: 0.9;
    }

    .filter {
        display: inline-grid;
        grid-auto-flow: column;
        column-gap: 10px;
        color: #6c757d;
    }

    .isnotExpired {
        display: none;
    }

    .tltStatus.expiredStatus {
        padding: 8px 0px 5px 0px;
    }

    .membersMentors {
        display: grid;
        grid-column-gap: 30px;
        grid-template-columns: 2fr 1fr;
    }

    span.statusValue {
        background-color: #efefef;
        padding: 11px 23px;
    }

    .puLabel .puValue input {
        width: 239px;
        margin-top: 3px;
    }

    .tsFor {
        z-index: 1;
    }

    .page-content {
        display: flex;
    }

    .mfg-img {
        text-align: right;
    }

    div.content {
        max-width: 1000px;
    }

    h1.pqHeadFirst {
        text-align: unset;
    }

    .all_profiles {
        display: grid;
        grid-auto-flow: column;
        grid-template-rows: 1fr;
        padding-top: 5px;
    }




    .home {
        width: 100%;
        display: flex;
        /*grid-template-columns: 3fr 1fr;*/
        margin: 10px 0px 10px 0px;
    }



    div#cisRsi {
        width: 100%;
        display: grid;
    }

    .tsKampagne {
        height: 100%;
    }

    .tsKampagnenBox {
        width: 100%;
        z-index: 10;
        min-height: 200px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 20px 20px;
    }




    .popoverContent1 {
        display: grid;
        row-gap: 5px;
    }

    .roundBackground {
        color: white;
        padding: 2px 10px;
        block-size: 22px;
        width: fit-content;
        border-radius: 10px;
    }

    .gray {
        background-color: #464b54;
    }

    .orng {
        background-color: #e97035;
    }

    .tsForIn {
        border: solid 1px #ebebeb;
        display: flex;
        justify-content: space-between;
        box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 10%);
        flex-direction: column;
    }

    .puMessage {
        display: grid;
        font-size: 15px;
    }



    .mfg-mentors {
        justify-content: right;
    }

    .tsSuchfeldDescription {
        padding-top: 10px;
        font-size: var(--grid-suchfeld-description-size);
        color: var(--grid-suchfeld-description-color);
    }


    .tsSuchfeldTitle {
        font-size: 19px;
        font-weight: bold;
        color: #465a64;
        min-height: 20px;
        padding: 10px 0px 0px 0px;
        margin-bottom: 5px;
    }

    .tsKampagneTitle {
        font-size: 20px;
        font-weight: bold;
        padding-left: 15px;
    }

    .tsSuchfeldImage {
        align-self: self-end;
        height: inherit;
    }

    .tsHeader {
        display: flex;
        width: 100%;
        grid-column-gap: 10px;
        float: left;
        clear: both;
        max-width: initial;
    }

        .tsHeader img {
            max-width: 100%;
            padding: 10px;
        }

    .tsSuchfeldImage img {
        width: 100%;
        object-fit: contain;
        height: 225px;
    }

    .tsSuchfeld {
        padding: 15px 15px 15px 15px;
        display: grid;
        grid-auto-flow: row;
        grid-template-rows: auto 1fr;
        height: 100%;
    }


    .tsSuchfeldBox {
        height: 100%;
    }

    .tsFor.tsForIn {
        cursor: pointer;
        background-color: white;
    }

        .tsFor.tsForIn:hover {
            background-color: whitesmoke;
        }

    .tsButton {
        margin-top: 15px;
        display: flex;
        justify-content: center;
        padding-bottom: 14px;
    }

    .tsForIn:hover {
        box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 15%);
    }

    .tsBtnDx {
        width: 95%;
    }

    .tsFor {
        flex-grow: 1;
        width: 100%;
        height: inherit;
        max-width: 350px;
    }

    .pinned .tsFor {
        max-width: 720px;
    }

    .pinned-description {
        overflow: hidden;
        max-width: 250px;
        display: -webkit-box;
        -webkit-line-clamp: 9;
        -webkit-box-orient: vertical;
    }

    .pinned .tsSuchfeldBox {
        display: grid;
        /*justify-items: center;*/
    }

    .pinned {
        padding-bottom: 15px;
        border-width: 1px;
        margin-bottom: 15px;
    }

    img.mfg-img {
        max-height: 370px;
        object-fit: cover;
    }

    .tsKampagneImage {
        width: 100px;
    }

    .mfgChangeStateButtons {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        margin-top: 10px;
        bottom: 0;
        background-color: white;
        position: sticky;
    }


    @media only screen and (max-width: 1200px) {
        .home {
            grid-template-columns: auto;
        }

        .tsKampagnenBox {
            display: grid;
            width: fit-content;
            grid-template-columns: 1fr 1fr 1fr;
            grid-row-gap: 15px;
        }

        .pinned .tsFor {
            max-width: 810px;
        }
    }

    .tsThemes {
        display: flex;
        gap: 20px;
        margin-top: 12px;
        height: 25px;
    }

    .mfgPopUpTlt {
        font-size: 15px;
        font-weight: bold;
    }

    body.views_projectcards_aspx .pqHeadFirst {
        margin-top: 0;
    }

    @media only screen and (max-width: 700px) {
        .tsKampagnenBox {
            grid-template-columns: 1fr;
            grid-row-gap: 20px;
        }

        .pinned .tsFor {
            max-width: 100%;
        }

        .pinned {
            width: 100%;
        }

        .home {
            justify-items: center;
        }

        .mfgChangeStateButtons {
            flex-direction: column-reverse;
            row-gap: 20px;
            align-items: center;
        }
    }
</style>
